import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import HeadComponent from "../components/HeadComponent/HeadComponent";
import dynamic from "next/dynamic";
import CustomSkeleton from "../components/CustomSkeleton/CustomSkeleton";
import FivaLayout from "../Layout/FivaLayout";
var DynamicOrcPhotosPage = dynamic(function() {
    return import("../components/_SupplyForm/BillUploader/MultipleUploader/MultipleUploader");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("../components/_SupplyForm/BillUploader/MultipleUploader/MultipleUploader")
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ _jsx(CustomSkeleton, {});
    }
});
var OcrPhotosPage = function() {
    var headerProps = {
        title: "Comparador de Tarifas de Luz | Fotograf\xeda Tu Factura",
        keywords: "Comparador de tarifas, fotograf\xeda de factura, an\xe1lisis OCR, ahorro en luz y gas, tarifas de energ\xeda, asesor\xeda energ\xe9tica, consultor\xeda energ\xe9tica, optimizaci\xf3n energ\xe9tica, asesoramiento el\xe9ctrico, energ\xedas renovables, eficiencia energ\xe9tica, digitalizaci\xf3n, ajuste de potencia",
        content: "Haz una foto a tu factura de luz y deja que nuestro avanzado sistema OCR haga el resto. Encuentra y compara las mejores tarifas de luz adaptadas a tu consumo real para tu hogar o negocio, todo gestionable de forma online."
    };
    return /*#__PURE__*/ _jsxs(FivaLayout, {
        blue: false,
        children: [
            /*#__PURE__*/ _jsx(HeadComponent, _object_spread({}, headerProps)),
            /*#__PURE__*/ _jsx(DynamicOrcPhotosPage, {})
        ]
    });
};
export default OcrPhotosPage;
